export const USER_PERMISSION_KEYS = {
  CUSTOMER_EDIT: 'customer:edit',
  CUSTOMER_EDIT_B2B: 'customer:edit:b2b',
  CUSTOMER_EDIT_B2C: 'customer:edit:b2c',
  CUSTOMER_CREATE_B2B: 'customer:create:b2b',
  CUSTOMER_CREATE_B2C: 'customer:create:b2c',
  ORDER_CREATE: 'order:create'
};
